import { ReactNode, memo } from 'react'

import styles from './posts-grid.module.scss'

type PostsChunkProps = {
  page?: number
  children?: ReactNode
}

function PostsGrid({ page, children }: PostsChunkProps): JSX.Element {
  return (
    <div data-page={page} className={styles.grid}>
      {children}
    </div>
  )
}

export default memo(PostsGrid)
